export const defaultLocation = { latitude: 47.0643929, longitude: 15.4342767 } // Graz

export const toGeoFloat = (str: string | number) => {
  return parseFloat(Number(str).toFixed(7))
}
